var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-image",class:_vm.roootClasses},[_vm._t("placeholder",function(){return [(_vm.pending || _vm.loadError)?_c('div',{staticClass:"base-image__placeholder"}):_vm._e()]}),_c('div',{staticClass:"base-image__cover",style:(_vm.imageStyle)}),_c('div',{staticClass:"base-image__body"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }